<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>SAÚDE</b></h5>
        </th>
      </tr>

      <tr>
        <td colspan="2">
          CARTÃO DO SUS: <b>{{ cartaoSus || '-' }}</b>
        </td>
        <td colspan="2">
          CADASTRO NACIONAL DE SAÚDE(CNS):
          <b>{{ usuario.cns || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          TEM DEFICIÊNCIA? <b>{{ usuario.deficiencia || '-' }}</b>
        </td>
        <td colspan="2">
          DATA DE INÍCIO DA DEFICIÊNCIA:
          <b>{{ usuario.deficiencia_data_inicio || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>QUAL É O TIPO DE DEFICIÊNCIA?</b></td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.def_cegueira">&#10003;</span>
          <span v-else>&#10761;</span>
          Cegueira
        </td>
        <td>
          <span v-if="usuario.def_baixa_visao">&#10003;</span>
          <span v-else>&#10761;</span>
          Baixa Visão
        </td>
        <td>
          <span v-if="usuario.def_surdez_servera">&#10003;</span>
          <span v-else>&#10761;</span>
          Surdez severa/profunda
        </td>
        <td>
          <span v-if="usuario.def_surdez_leve">&#10003;</span>
          <span v-else>&#10761;</span>
          Surdez leve/moderada
        </td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.def_fisica">&#10003;</span>
          <span v-else>&#10761;</span>
          Deficiência física
        </td>
        <td>
          <span v-if="usuario.def_mental_intelectual">&#10003;</span>
          <span v-else>&#10761;</span>
          Deficiência mental ou intelectual
        </td>
        <td>
          <span v-if="usuario.def_sindrome_down">&#10003;</span>
          <span v-else>&#10761;</span>
          Síndrome de Down
        </td>
        <td>
          <span v-if="usuario.def_transtorno_doenca_mental">&#10003;</span>
          <span v-else>&#10761;</span>
          Transtorno/doença mental
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <b>EM FUNÇÃO DESSA DEFICIÊNCIA, RECEBE CUIDADOS PERMANENTES DE TERCEIROS?</b>
        </td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ajuda_nao_recebida">&#10003;</span>
          <span v-else>&#10761;</span> NÃO
        </td>
        <td>
          <span v-if="usuario.ajuda_familia">&#10003;</span>
          <span v-else>&#10761;</span> Família
        </td>
        <td colspan="2">
          <span v-if="usuario.ajuda_especializada">&#10003;</span>
          <span v-else>&#10761;</span> Cuidador especializado
        </td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ajuda_vizinhos">&#10003;</span>
          <span v-else>&#10761;</span> Vizinho
        </td>
        <td>
          <span v-if="usuario.ajuda_instituicao">&#10003;</span>
          <span v-else>&#10761;</span> Instituição
        </td>
        <td colspan="2">
          <span v-if="usuario.ajuda_outra_forma">&#10003;</span>
          <span v-else>&#10761;</span> Outra forma
        </td>
      </tr>

      <tr>
        <td colspan="4">
          NOME DO RESPONSÁVEL: <b>{{ usuario.responsavel_nome || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          REMÉDIO CONTROLADO:
          <b>{{ usuario.uso_remedio_controlado || '-' }}</b>
        </td>
        <td colspan="2">
          MEDICAMENTO:
          <b>{{ usuario.remedio_controlado_nome || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          ÁLCOOL: <b>{{ usuario.uso_abusivo_alcool || '-' }}</b>
        </td>
        <td colspan="2">
          DROGAS: <b>{{ usuario.uso_abusivo_drogas || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          DROGA: <b>{{ usuario.droga_nome || '-' }}</b>
        </td>
        <td>
          TEMPO: <b>{{ usuario.droga_tempo_uso || '-' }}</b>
        </td>
        <td>
          PERÍODO: <b>{{ usuario.droga_periodo_uso || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          DOENÇA: <b>{{ usuario.portador_doenca || '-' }}</b>
        </td>
        <td colspan="2">
          CID:
          <b>{{ Array.isArray(usuario.doenca_nome) ? usuario.doenca_nome.join(', ') : (usuario.doenca_nome || '-') }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          Estabelecimento de Saúde
        </td>
      </tr>

      <tr>
        <td colspan="2">
          NOME:
          <b>{{ usuario.estabelecimento_saude_nome || '-' }}</b>
        </td>
        <td colspan="2">
          CÓDIGO:
          <b>{{ usuario.estabelecimento_saude_codigo || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          TRATAMENTO:
          <b>{{ usuario.faz_tratamento_saude || '-' }}</b>
        </td>
        <td colspan="2">
          QUAL:
          <b>{{ usuario.qual_tratamento_saude || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          INTERNADO:
          <b>{{ usuario.internado_tratamento || '-' }}</b>
        </td>
        <td colspan="2">
          PERÍODO:
          <b>{{ usuario.periodo_tratamento_saude || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          LOCAL:
          <b>{{ usuario.local_tratamento_saude || '-' }}</b>
        </td>
        <td colspan="2">
          VIDA SEXUAL:
          <b>{{ usuario.vida_sexual || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          PRESERVATIVO:
          <b>{{ usuario.uso_preservativo || '-' }}</b>
        </td>
        <td colspan="2">
          PARCEIRO FIXO:
          <b>{{ usuario.parceiro_fixo || '-' }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario", "cartaoSus"],
};
</script>